import { Component, Input, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinancialSummary } from '../../order-v2.types';

@Component({
  selector: 'app-financial-summary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './financial-summary.component.html',
  styleUrl: './financial-summary.component.scss',
})
export class FinancialSummaryComponent {
  @Input({ required: true }) financial!: FinancialSummary;

  formatCents(value: number): string {
    return ((value ?? 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  formatAdjustment(value: number): string {
    const formatted = this.formatCents(value);
    if ((value ?? 0) > 0) return `+${formatted}`;
    return formatted;
  }

  adjustmentsPctLabel(): string | null {
    const s = this.financial.itemsSubtotal + this.financial.shipping;
    if (s === 0) return null;
    const pct = Math.round((this.financial.totalAdjustments / s) * 100);
    if (Math.abs(pct) < 5) return null;
    return `${pct > 0 ? '+' : ''}${pct}%`;
  }
}
